 <div class="avatar-wrapper" [ngClass]="{'is-responsive': isResponsive}">
    <img alt="" class="rounded-circle z-depth-0 avatar-image" [ngClass]="{'is-responsive': isResponsive}"
         [src]="url" alt="{{ alt }}" *ngIf="showImage"/>
    <i class="icon-edponline-Bop-081" *ngIf="!showImage" aria-hidden="true"></i>
</div>
